import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";

import {CONFIG} from "../global-config";

export const openmeterApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${CONFIG.services.openmeter.baseUrl}/openmeterApi`,
    prepareHeaders: async headers => {
      headers.set('ContentType', "application/cloudevents+json")
      headers.set('Authorization', `Bearer ${CONFIG.services.openmeter.apiKey}`) // TODO config variable in secrets
      return headers;
    },
    headers: {
      ContentType: "application/cloudevents+json",
      Authorization: `Bearer ${CONFIG.services.openmeter.apiKey}`
    },
  }),
  endpoints: () => ({})
  /* endpoints: (build) => ({
    listInvoicesGet: build.query<OMListInvoicesQueryResult, {customers:string[]}>({
      query: (customers) => ({
          url: `billing/invoices`,
          params: {customers}
        }),
    }),
  }), */
})
